(function () {

  'use strict';

  // Input data are coming in context.msiArgs

  function pxMsiArguments(
    toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context'
      },
      templateUrl: 'app/components/softwareDistribution/msiArguments/msiArguments.template.html',
      link: function (scope) {

        scope.wrapper1Copied = false;
        scope.wrapper2Copied = false;
        scope.wrapper1 = scope.context.msiArgs.wrapper1;
        scope.wrapper2 = scope.context.msiArgs.wrapper2;
        scope.tenantId = scope.context.msiArgs.tenantId;

        scope.key = {
          name: '',
          accept: false
        };
        scope.hideUI_elements = false;
        scope.secret = null;

        scope.copyMsiArgument = function (event, wrapper) {
          const input = document.createElement('input');
          if (event.ctrlKey) {
            wrapper = scope.tenantId;
          }
          input.setAttribute('value', wrapper);
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);

          scope.wrapper1Copied = wrapper === scope.wrapper1;
          scope.wrapper2Copied = wrapper === scope.wrapper2;

          toastr.success($filter('translate')('CopyToClipboard'));
        };
      }
    };
  }

  pxMsiArguments.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxMsiArguments', pxMsiArguments);

})();
